var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9C0.25 10.0338 1.09125 10.875 2.125 10.875C3.15875 10.875 4 10.0338 4 9C4 7.96625 3.15875 7.125 2.125 7.125C1.09125 7.125 0.25 7.96625 0.25 9Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 15.25C0.25 16.2838 1.09125 17.125 2.125 17.125C3.15875 17.125 4 16.2838 4 15.25C4 14.2162 3.15875 13.375 2.125 13.375C1.09125 13.375 0.25 14.2162 0.25 15.25Z",
    fill: "#current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.75C0.25 3.78375 1.09125 4.625 2.125 4.625C3.15875 4.625 4 3.78375 4 2.75C4 1.71625 3.15875 0.875 2.125 0.875C1.09125 0.875 0.25 1.71625 0.25 2.75Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/threeDotVertical.7125262389332c2e11c140c7240f8c5c.svg";
export { ForwardRef as ReactComponent };